export default class BcpImportBtn extends HTMLAnchorElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
    }

    events() {
        this.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            window.HegydCore.initRemoteModal(
                '#modal',
                this.href,
                function(){
                    $('input[name="year-selected"]').val($('select[name="year"]').val());
                },
                (data) => {
                    if(data.hasOwnProperty('errors')){
                        if(data.errors.length > 0){
                            toastr.error(data.errors);
                        }else{
                            toastr.success('Fichier importé !');
                        }
                    }

                    if(data.hasOwnProperty('viewKpi')){
                        $('#kpi-block').empty().html(data.viewKpi);
                    }

                    window.AppDatatable.table.ajax.reload();
                },
                () => {
                     toastr.error('Une erreur s\'est produite');
                }
            );
        });
    }
}
